<section class="contact-top">
    
    <div class="inner_sec">

       <div class="container">     
        <h2>Molding Machine Enhancement</h2>
       </div> 
             
        <div class="tabbing_sec">

        <div class="product_list">

            <div class="product_box conveyer_sec">
              <div class="container">
                <!-- <h3>Conveyor Systems</h3> -->
                <div class="row">   
                    <div class="col-sm-4" *ngFor="let data of conveyersystem">
                        <div class="productItem">
                            <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4>{{data.title}}</h4>
                        </div>
                    </div>
                </div>
              </div>
            </div>

            <!-- <div class="product_box material_movement">
            <div class="container">
                <h3>Conveyor Systems</h3>
                <div class="row">   
                    <div class="col-sm-4" *ngFor="let data of materialmove">
                        <div class="productItem">
                            <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4>{{data.title}}</h4>
                        </div>
                    </div>
                </div>
            </div>
            </div>

           <div class="product_box material_storage">
            <div class="container">
                <h3>Material Storage System</h3>
                <div class="row">   
                    <div class="col-sm-4" *ngFor="let data of materialstorage">
                        <div class="productItem">
                            <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4>{{data.title}}</h4>
                        </div>
                    </div>
                </div>
            </div>
           </div> -->

        </div>
              
        </div>
    </div>

</section>
